import { render, staticRenderFns } from "./detailsRepresentantes.vue?vue&type=template&id=69c1f75c&"
import script from "./detailsRepresentantes.vue?vue&type=script&lang=js&"
export * from "./detailsRepresentantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports